import React, {Fragment, useState} from "react";
import QrReader from 'react-qr-reader';
import Div100vh from "../../../../uq-ui/components/div-100";
import LayoutComponentsHeader from "../../../../layout/ui/components/header";
import styles from "./style.css";
import ConfirmModal from "../../../../uq-ui/components/confirm-modal";
import UQButton from "../../../../uq-ui/components/button";
import {cleanSticker} from "../../../../stickers/store/entities/stickers/actions";
import {useDispatch} from "react-redux";


export default function ModeratorCleanSticker() {
    const [error, setError] = useState<string>("");
    const [stickerIdToDelete, setStickerIdToDelete] = useState<string | null>(null);
    const [isCleaning, setIsCleaning] = useState<boolean>(false);
    const dispatch: (any) => Promise<any> = useDispatch();

    const handleScan = data => {
        if (data) {
            try {
                const url = new URL(data);
                const splitted = url.pathname.split("/");
                const stickerId = splitted[1];
                setStickerIdToDelete(stickerId);
            } catch (e) {
                setError("Invalid URL")
            }
        }
    };

    const handleError = err => {
        setError("Failed to Scan or open Camera")
    };

    const showScanner = !stickerIdToDelete && !isCleaning;
    return (
        <Fragment>
            {/*@ts-ignore*/}
            <LayoutComponentsHeader showBackBtn={false}/>
            <ConfirmModal
                show={!!stickerIdToDelete}
                title={"Reset Sticker"}
                styles={{zIndex: 105}}
                showConfirmBtn={false}
                onClose={() => setStickerIdToDelete(null)}
            >
                <div className={styles.deleteModelContainer}>
                    {`Are you sure you want to delete sticker id: ${stickerIdToDelete}`}
                    <UQButton label={'RESET'}
                              containerClass={styles.attachFloatButton}
                              theme={'danger'}
                              onPress={() => {
                                  setIsCleaning(true);
                                  dispatch(cleanSticker(stickerIdToDelete))
                                      .then(() => setIsCleaning(false))
                                      .catch(() => setIsCleaning(false));
                                  setStickerIdToDelete(null);
                              }}/>
                </div>
            </ConfirmModal>
            <Div100vh className={styles.page} style={{minHeight: '100rvh'}}>
                <div className={styles.header}>
                    <div className={`${styles.title} font-title`}
                         dangerouslySetInnerHTML={{__html: "Please scan<br>Llama QR"}}/>
                </div>
                <div className={styles.qrContainer}>
                    {showScanner && <QrReader
                      delay={300}
                      onError={handleError}
                      onScan={handleScan}
                      style={{width: '80%'}}
                    />}

                </div>
                <div className={styles.errorContainer}>
                    {error}
                </div>
            </Div100vh>
        </Fragment>
    )
}

